<template>
  <component :is="component" v-bind="attributes" v-on="handlers">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: ''
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    component() {
      return this.href ? 'a' : 'span';
    },
    attributes() {
      return this.href
        ? {
            href: this.href,
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        : {};
    },
    handlers() {
      return this.href ? { click: this.onClick } : {};
    }
  },
  methods: {
    onClick(event) {
      if (this.locked) {
        event.preventDefault();
      }
    }
  }
};
</script>
